import type { RouteRecordRaw } from "vue-router";

export enum ReservationListType {
  TYPE_ALL = "all",
  TYPE_ARRIVAL_TODAY = "arrival-today",
  TYPE_DEPARTURE_TODAY = "departure-today",
  TYPE_ARRIVAL_FROM_TODAY = "arrival-from-today",
  TYPE_DEPARTURE_FROM_TODAY = "departure-from-today",
  TYPE_THIS_WEEK = "week",
  TYPE_UNCONFIRMED = "unconfirmed",
}

export const RESERVATION_LIST_FALLBACK_TYPE = ReservationListType.TYPE_ALL;

const routes = <RouteRecordRaw[]>[
  {
    path: "/res",
    name: "reservations",
    component: () => import("@web/features/Reservations/ReservationsContainer.vue"),
    redirect: (props) => {
      return {
        name: "reservation-list",
        params: { type: RESERVATION_LIST_FALLBACK_TYPE, ...props?.params },
      };
    },
    children: [
      {
        path: "/:catchAll(.*)",
        redirect: {
          name: "reservation-list",
          params: { type: RESERVATION_LIST_FALLBACK_TYPE },
        },
      },
      {
        path: "li/:type/:reservationId?",
        name: "reservation-list",
        component: () => import("./ReservationsView.vue"),
        beforeEnter: (to) => {
          const type = to.params.type as ReservationListType;
          const { reservationId } = to.params;

          if (!Object.values(ReservationListType).includes(type)) {
            // Keeps the query and hash, e.g. ?notification=<IRI> of a notification link.
            return {
              name: "reservation-list",
              params: { type: RESERVATION_LIST_FALLBACK_TYPE, reservationId },
              query: to.query,
              hash: to.hash,
            };
          }

          return true;
        },
      },
    ],
  },
];

export default routes;
